module.exports = __webpack_public_path__ + "static/media/sliders.fc72f20a.svg";